export default {"src":"/newStatic/_next/static/media/grid-menu-icon.18c661c1.svg","height":16,"width":16};